import { ExternalLink, PlayCircle, ShieldAlert, Wrench } from "lucide-react";

/** Savoir terrain : fiches de panne réelles citées par l'assistant (gestes, sources, vidéo validée). */
export const SavoirFiches = ({ fiches, sombre = false }) => {
  if (!fiches?.length) return null;
  const titre = sombre ? "text-white/40" : "text-slate-400";
  const carte = sombre ? "border-white/10 bg-white/5" : "border-slate-200 bg-slate-50";
  const texte = sombre ? "text-white/80" : "text-slate-700";
  const doux = sombre ? "text-white/50" : "text-slate-500";

  return (
    <div className="space-y-2" data-testid="savoir-fiches">
      <div className={`text-[11px] uppercase tracking-[0.2em] ${titre}`}>Savoir terrain BKPRO</div>
      {fiches.map((f) => (
        <div key={f.id} data-testid={`savoir-fiche-${f.id}`} className={`rounded-xl border ${carte} p-3 space-y-2`}>
          <div className={`text-sm font-semibold ${sombre ? "text-white" : "text-slate-900"}`}>
            {f.symptome}
            {f.codes?.length > 0 && (
              <span className="ml-2 text-[10px] font-mono rounded bg-[#005CFF]/15 text-[#4D93FF] px-1.5 py-0.5">
                {f.codes.slice(0, 3).join(" · ")}
              </span>
            )}
          </div>

          {f.gestes?.length > 0 && (
            <ul className={`space-y-1 text-sm ${texte}`}>
              {f.gestes.map((g, i) => (
                <li key={i} className="flex items-start gap-2">
                  <Wrench size={13} className="mt-0.5 shrink-0 text-[#4D93FF]" /> {g}
                </li>
              ))}
            </ul>
          )}

          {f.quand_bkpro && (
            <div className={`flex items-start gap-2 text-xs ${doux}`}>
              <ShieldAlert size={13} className="mt-0.5 shrink-0 text-amber-500" /> {f.quand_bkpro}
            </div>
          )}

          {f.video_url && (
            <a
              href={f.video_url}
              target="_blank"
              rel="noreferrer"
              data-testid={`savoir-video-${f.id}`}
              className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#4D93FF] hover:underline"
            >
              <PlayCircle size={14} /> Voir la vidéo (validée par BKPRO)
            </a>
          )}

          {f.sources?.length > 0 && (
            <div className="flex flex-wrap gap-x-3 gap-y-1">
              {f.sources.map((s, i) => (
                <a
                  key={i}
                  href={s.url}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`savoir-source-${f.id}-${i}`}
                  className={`inline-flex items-center gap-1 text-[11px] ${doux} hover:text-[#4D93FF]`}
                >
                  <ExternalLink size={11} /> {s.titre || "Source"}
                </a>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default SavoirFiches;
